import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

interface ViewOrderSkeletonProps {
    isDesktop: boolean;
}

const DetailSectionSkeleton = () => {
    return (
        <div className="rounded-xl border bg-card py-8 px-6">
            <div className="flex flex-col gap-3">
                <Skeleton className="h-8 w-64" />
                <Skeleton className="h-4 w-full max-w-xl" />
            </div>

            <div className="mt-6 rounded-lg border p-4">
                <Skeleton className="h-16 w-full rounded-lg" />
            </div>

            <div className="mt-6 flex flex-col gap-4">
                {[1, 2, 3, 4].map((row) => (
                    <div key={row} className="flex items-start gap-4 rounded-lg border p-4">
                        <Skeleton className="h-20 w-20 shrink-0" />
                        <div className="flex w-full flex-col gap-3">
                            <Skeleton className="h-4 w-3/4" />
                            <Skeleton className="h-4 w-1/2" />
                            <div className="flex items-center justify-between gap-3">
                                <Skeleton className="h-4 w-24" />
                                <Skeleton className="h-4 w-28" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const MobileResumeFooterSkeleton = () => {
    return (
        <div className="sticky bottom-0 left-0 z-10 w-full border-t bg-background px-4 pt-2 pb-4">
            <div className="mx-auto flex w-[15rem] flex-col items-center gap-2 rounded-full bg-primary/10 px-4 py-2">
                <Skeleton className="h-9 w-full rounded-full" />
                <Skeleton className="h-3 w-28" />
            </div>
        </div>
    );
};

/**
 * Displays the loading skeleton for the ViewOrder checkout page.
 */
export const ViewOrderSkeleton: React.FC<ViewOrderSkeletonProps> = ({ isDesktop }) => {
    return (
        <>
            <div className="py-4 px-6">
                <div
                    className={cn("flex w-full flex-col gap-2", {
                        "w-full": !isDesktop,
                        "lg:w-[80%] xl:w-[80%] 2xl:w-[60%] mx-auto": isDesktop,
                    })}
                >
                    <DetailSectionSkeleton />
                </div>
            </div>
            {!isDesktop && <MobileResumeFooterSkeleton />}
        </>
    );
};
